import { combineReducers } from "redux";
import register from "./register";
import addBuyer from "./addBuyer";
import auth from "./auth";
import pageRoot from "./pageRoot";
import comapny from "./company";
import errorReducer from "./errorReducer";
import clothQualityReducer from "./clothQuality";
import contractReducer from "./contract";
import yarnQualityReducer from "./yarnQaulity";
import yarnIssence from "./yarnIssuence";
import sizer from "./Sizer/sizer";
import sendYarn from "./Sizer/sendYarn";
import dispatches from "./dispatch";
import clothReturn from "./clothReturn";
import payments from "./payment";
import previewInvoice from "./previewInvoice";
// import tax from "./tax";
import weave from "../Reducers/Setting/weave";
import selvedge from "../Reducers/Setting/selvedge";

import hsCode from "../Reducers/Setting/hsCode";
import tax from "../Reducers/Setting/tax";
// import programHistory from "./Sizer/programHistory";
import addProgam from "./Sizer/addProgram";

const reducers = combineReducers({
  register: register,
  auth: auth,
  addBuyer: addBuyer,
  pageRoot: pageRoot,
  comapny: comapny,
  errorReducer: errorReducer,
  clothQualityReducer: clothQualityReducer,
  contractReducer: contractReducer,
  yarnQualityReducer: yarnQualityReducer,
  yarnIssence: yarnIssence,
  sizer: sizer,
  sendYarn: sendYarn,
  dispatches: dispatches,
  clothReturn: clothReturn,
  payments: payments,
  previewInvoice: previewInvoice,
  // tax: tax,
  addProgam: addProgam,
  weave: weave,
  selvedge: selvedge,
  hsCode: hsCode,
  tax: tax,
});
const rootReducer = (state, action) => {
  if (action.type === "RESET_CART") {
    state = undefined; // this will set the state to initial automatically
  }
  return reducers(state, action);
};
export default rootReducer;
